<content>
    <form [formGroup]="newEditForm" [ngClass]="{'show-error':showError}">
        <div class="info">{{'global.infoRequired' | translate}}</div>
        <div class="entry-4-modal">
            <label>{{'mantenimientoConfecciones.confeccion.confeccion' | translate}} *</label>
            <input type="text" formControlName="des">
        </div>
        <div class="entry-4-modal">
            <label>{{'mantenimientoConfecciones.confeccion.alias' | translate}}</label>
            <input type="text" formControlName="alias">
        </div>
        <div class="entry-4-modal">
            <label>{{'mantenimientoConfecciones.confeccion.etiquetador' | translate}}</label>
            <input type="text" formControlName="etiquetador">
        </div>
        <div class="entry-4-modal">
            <label>{{'mantenimientoConfecciones.confeccion.denominacion' | translate}}</label>
            <input type="text" formControlName="denominacion">
        </div>
        <div class="entry-4-modal">
            <label>{{'mantenimientoConfecciones.confeccion.tipoConfeccion' | translate}}</label>
            <input type="text" formControlName="tipo">
        </div>
        <!-- <div class="entry-4-modal">
            <label>{{'mantenimientoConfecciones.confeccion.pesoCaja' | translate}}</label>
            <input type="number" formControlName="peso">
        </div> -->
        <div class="entry-4-modal" *ngIf="_confeccion && _confeccion.tipoConfeccionId == 2">
          <label>{{'mantenimientoConfecciones.confeccion.pesoPallet' | translate}}</label>
          <input type="number" readonly formControlName="pesoPallet">
        </div>
        <div class="entry-4-modal alignment-start">
          <input type="checkbox" id="confeccioActiva" formControlName="activo">
          <label for="confeccioActiva">{{'mantenimientoConfecciones.confeccion.activa' | translate}}</label>
        </div>
    </form>
</content>
<footer class="button-bar-right">
    <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
    <button (click)="save()">{{'global.actualizar' | translate}}</button>
</footer>
<app-toast *ngIf="(showError) && mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>
